import { z } from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';
import { practiceIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import {
    CLIENT_BILLING_SETTINGS_TYPES,
    FEES_SETTINGS_TYPE,
    feesSettingsValueSchema,
    SUPERBILL_SETTINGS_TYPE,
    superbillSettingsValueSchema,
} from './client-billing-settings.models';

export const GET_CLIENT_BILLING_SETTINGS_BY_TYPE_TYPE = 'client-billing-settings/get-by-type';

export const clientBillingSettingsSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal(SUPERBILL_SETTINGS_TYPE), value: superbillSettingsValueSchema }),
    z.object({ type: z.literal(FEES_SETTINGS_TYPE), value: feesSettingsValueSchema }),
]);

export type ClientBillingSettingsValue = z.infer<typeof clientBillingSettingsSchema>;

export const getClientBillingSettingsByType = defineQuery(
    GET_CLIENT_BILLING_SETTINGS_BY_TYPE_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.recordId),
        type: z.enum(CLIENT_BILLING_SETTINGS_TYPES),
    }),
    clientBillingSettingsSchema,
);
